import React, { useEffect, useState } from "react";
import "./Circular.css";

function Circular() {
  const [circulars, setCirculars] = useState([]);

  useEffect(() => {
    fetch("https://aadyaacademy.org/api/circulars")
      .then((response) => response.json())
      .then((data) => {
        const today = new Date();
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(today.getDate() - 7);

        // Filter only circulars with 'fromdate' in the last 7 days
        const filtered = data.filter((circular) => {
          if (!circular.fromdate) return false; // skip if no date
          const circularDate = new Date(circular.fromdate);
          return circularDate >= oneWeekAgo && circularDate <= today;
        });

        setCirculars(filtered);
      })
      .catch((error) => console.error("Error fetching circulars:", error));
  }, []);

  return (
    <>
      <div className="circular-header">
        <h1>Circular</h1>
        <div className="circ-add-btn">
          <button>+</button>
        </div>
      </div>
      <div className="circul-div">
        {circulars.length === 0 ? (
          <p>No circulars available.</p>
        ) : (
          circulars.map((circular, index) => (
            <div className="circular-div" key={index}>
              <div className="content-a">
                <h4>{circular.title}</h4>
                <p><strong>Details:</strong> {circular.description}</p>
                <p><strong>Category:</strong> {circular.category}</p>
                <p><strong>Valid From:</strong> {circular.fromdate || "Not specified"}</p>
                <p><strong>Valid To:</strong> {circular.todate || "Not specified"}</p>
                {circular.pdf_file_path && (
                  <p>
                    <a
                      href={circular.pdf_file_path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open Circular PDF
                    </a>
                  </p>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
}

export default Circular;
